/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErrorDef } from './errorDef';
import { RolloutTargetOperationStatus } from './rolloutTargetOperationStatus';


export interface RolloutTargetStatus { 
    /**
     * Generated Target ID
     */
    target_id?: string;
    /**
     * Target entity ID
     */
    target_entity_id?: string;
    status?: RolloutTargetOperationStatus;
    /**
     * List of errors.
     */
    errors?: Array<ErrorDef>;
}
export namespace RolloutTargetStatus {
}


